export default __webpack_public_path__ + "static/media/logo_horizontal_rehab.b9762c1a.png";